// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var id = "ff7knizrg1";

var publicKey = "public_LTITuhHFzH8N6pTJcwrzhK5ImLE=";

exports.id = id;
exports.publicKey = publicKey;
/* No side effect */
